import { Component, Input } from "@angular/core";
import { User, Comment, Discussion, PanelMember } from "../../../../models";

@Component({
  selector: "add-comment-button",
  templateUrl: "./add-comment-button.component.html",
  styleUrls: [
    "./add-comment-button.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class AddCommentButtonComponent {
  @Input() currentUser: User;
  @Input() discussion: Discussion;
  @Input() currentPanelMember: PanelMember;
  @Input() commentRepliedTo: Comment;

  constructor() {}
}
